// utils/gtm.ts
"use client";
import { sendGTMEvent } from "@next/third-parties/google";
import { capturePostHogEvent } from "@/utils/posthog";

export const trackEvent = (event: string, data: Record<string, any>) => {
  if (typeof window !== "undefined") {
    sendGTMEvent({ event, ...data });
    void capturePostHogEvent(event, data);
  }
};

// Pushes a plain data object onto the GTM dataLayer without shaping it as an
// event (no `event` key). Use this for session-level attribution values
// (e.g. partner=cdm) that should ride along with every later GTM trigger,
// as opposed to trackEvent, which is for one-off business events.
export const pushToDataLayer = (data: Record<string, any>) => {
  if (typeof window === "undefined") return;

  try {
    sendGTMEvent(data);
  } catch (error) {
    console.warn("GTM dataLayer push failed", error);
  }
};

export const SEARCH_HOTEL_EVENT = "search_hotel";
export const VIEW_ITEM_LIST_EVENT = "view_item_list";
export const SELECT_ITEM_EVENT = "select_item";
export const VIEW_ITEM_EVENT = "view_item";

export const ADD_TO_CART_EVENT = "add_to_cart";
export const VIEW_CART_EVENT = "view_cart";

export const BEGIN_CHECKOUT_EVENT = "begin_checkout";
export const PURCHASE_EVENT = "purchase";
export const GENERATE_LEAD_EVENT = "generate_lead";
export const BOOKING_CONFIRMED_EVENT = "booking_confirmed";

export const LOGIN_EVENT = "login";
export const SIGNUP_EVENT = "signup";
export const LOGOUT_EVENT = "logout";
